import React, { useContext } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import StoreContext from '../../context/StoreContext'
import SoldOutIcon from './soldOut'
import Img from 'gatsby-image'
import styled from 'styled-components'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
  @media screen and (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

 const SoldOut = styled.div`
  position:absolute;
  top:0;
  right:10px;
   small {
     background:white;
     text-transform:uppercase;
     padding:5px;
     margin-top:10px;
     letter-spacing:3px;
     display:block;
   }
  `

 const ProductImageAvail = styled.div`
      position: relative;
`

 const Product = styled.div`
  a {
    display:block;
  }
`

 const Title = styled.span`
`

 const PriceTag = styled.span`
  font-size: 1rem;
`

const ProductGrid = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)

  const { allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allShopifyProduct(sort: { fields: [title], order: ASC }, filter: {productType: {eq: "Shirt"}}) {
          edges {
            node {
              id
              title
              handle
              availableForSale
              createdAt
              productType
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 910) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              variants {
                price
              }
            }
          }
        }
      }
    `
  )

  const getPrice = price =>
    Intl.NumberFormat(undefined, {
      currency: checkout.currencyCode ? checkout.currencyCode : 'USD',
      minimumFractionDigits: 2,
      style: 'currency',
    }).format(parseFloat(price ? price : 0))


  return (
    <Grid>
      {allShopifyProduct.edges ? (
        allShopifyProduct.edges.map(
          ({
            node: {
              id,
              handle,
              title,
              availableForSale,
              images: [firstImage],
              variants: [firstVariant],
            },
          }) => (
            <Product key={id}>
              <ProductImageAvail>
              <Link to={`/product/${handle}/`}>
                {firstImage && firstImage.localFile && (
                  <Img
                    fluid={firstImage.localFile.childImageSharp.fluid}
                    alt={handle}
                  />
                )}
                
              </Link>
              <SoldOut>
                {availableForSale ? '' : <small>Sold Out</small>} 
              </SoldOut>
              </ProductImageAvail>
              
              <div>
              <Link to={`/product/${handle}/`}>
                <Title>{title}</Title>
              </Link>
              </div>
              
              <PriceTag>{getPrice(firstVariant.price)}</PriceTag>
            </Product>
          )
        )
      ) : (
        <p>No Products found!</p>
      )}
    </Grid>
  )
}

export default ProductGrid